// Exchange-eligible parts API (SUPERADMIN only)
// Which part types can be quoted with a trade-in (exchange) price.

import axiosInstance from './axiosInstance';
import { API_ENDPOINTS } from '../config/api.config';

const { EXCHANGE_PARTS } = API_ENDPOINTS;

export const exchangePartsApi = {
  /** GET /admin/exchange-parts/ — all entries (active + inactive) */
  getList: () => axiosInstance.get(EXCHANGE_PARTS.LIST),

  /** POST /admin/exchange-parts/ — { name } */
  create: (data) => axiosInstance.post(EXCHANGE_PARTS.LIST, data),

  /** PATCH /admin/exchange-parts/<id>/ — { name } or { is_active } */
  update: (id, data) => axiosInstance.patch(EXCHANGE_PARTS.DETAIL(id), data),

  /** DELETE /admin/exchange-parts/<id>/ — permanent removal */
  remove: (id) => axiosInstance.delete(EXCHANGE_PARTS.DETAIL(id)),
};
